"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _StarRate = _interopRequireDefault(require("@material-ui/icons/StarRate"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _UTLabel = _interopRequireDefault(require("@widergy/energy-ui/dist/components/UTLabel"));

var _constants = require("./constants");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Star = function Star(_ref) {
  var _textVariants;

  var name = _ref.name,
      onMouseLeave = _ref.onMouseLeave,
      hovered = _ref.hovered,
      selected = _ref.selected,
      isFirst = _ref.isFirst,
      isLast = _ref.isLast,
      starColor = _ref.starColor,
      order = _ref.order,
      value = _ref.value,
      onClick = _ref.onClick,
      onHover = _ref.onHover,
      classes = _ref.classes,
      textVariant = _ref.textVariant;

  var handleClick = function handleClick() {
    return onClick(order, value);
  };

  var handleHover = function handleHover() {
    return onHover(order);
  };

  var onFocus = function onFocus() {};

  var showPropColor = starColor && (hovered || selected);
  var textVariants = (_textVariants = {}, _defineProperty(_textVariants, _constants.SIDE_TEXT, {
    containerClass: isFirst ? _stylesModule["default"].first : isLast && _stylesModule["default"].last,
    showLabel: isFirst || isLast
  }), _defineProperty(_textVariants, _constants.BOTTOM_TEXT, {
    containerClass: _stylesModule["default"].withTextBottom,
    showLabel: true
  }), _defineProperty(_textVariants, _constants.NO_TEXT, {
    containerClass: '',
    showLabel: false
  }), _textVariants);
  var textVariantToUse = textVariants[textVariant] || textVariants[_constants.SIDE_TEXT];
  return _react["default"].createElement("div", {
    className: "".concat(_stylesModule["default"].container, " ").concat(textVariantToUse.containerClass)
  }, _react["default"].createElement(_IconButton["default"], {
    onFocus: onFocus,
    onMouseOver: handleHover,
    onMouseLeave: onMouseLeave,
    onClick: handleClick,
    style: showPropColor ? {
      color: starColor
    } : {},
    className: "".concat(_stylesModule["default"].starButton, " ").concat(hovered && _stylesModule["default"].starHovered, " ").concat(selected && _stylesModule["default"].starsPainted)
  }, _react["default"].createElement(_StarRate["default"], {
    className: _stylesModule["default"].starSize
  })), textVariantToUse.showLabel && _react["default"].createElement(_UTLabel["default"], {
    className: "".concat(_stylesModule["default"].text, " ").concat(classes.label)
  }, name));
};

Star.propTypes = {
  onClick: _propTypes.func,
  onHover: _propTypes.func,
  onMouseLeave: _propTypes.func,
  order: _propTypes.number,
  value: _propTypes.number,
  hovered: _propTypes.string,
  selected: _propTypes.string,
  name: _propTypes.string,
  isFirst: _propTypes.bool,
  isLast: _propTypes.bool,
  starColor: _propTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  classes: _propTypes.any,
  textVariant: _propTypes.string
};
var _default = Star;
exports["default"] = _default;